import React, { useState, useEffect, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSidebarStore } from "../../store/useSidebarStore";
import { useAuthStore } from "../../store/useAuthStore";
import { useAuthModalStore } from "../../store/useAuthModalStore";
import { useDeviceDetect } from "../../hooks/useDeviceDetect";
import { storage } from "../../utils/storage";
import Sidebar from "./Sidebar";
import HeaderCredit from "./HeaderCredit";
import ProfileMenu from "./ProfileMenu";
import { Menu as MenuIcon } from "../icons";
import { Search as SearchIcon } from "../icons";
import GlobalSearch from "../search/GlobalSearch";
import { GiftSkyla } from "../icons";
import { Chat as MessageIcon } from "../icons";
import NotificationDropdown from "../notification/NotificationDropdown";

const DEFAULT_AVATAR = "//img2.distributedresourcestorage.com/avatar/57268122/s?t=0";

const Header = () => {
  const [showLogo, setShowLogo] = useState(window.innerWidth > 768);
  const [searchOpen, setSearchOpen] = useState(false);
  const { isCollapsed, toggleCollapse, toggle } = useSidebarStore();
  const { isAuthenticated } = useAuthStore();
  const { isMobile } = useDeviceDetect();
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => setShowLogo(window.innerWidth > 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleMenuClick = useCallback(() => {
    if (isMobile) toggle();
    else toggleCollapse();
  }, [isMobile, toggle, toggleCollapse]);

  const handleSupportClick = useCallback(() => {
    window.$crisp = [];
    window.CRISP_WEBSITE_ID = "b4d39101-0a81-4b37-8189-3aa30f93b3f8";
    window.$crisp.push(["config", "container:fullpage", true]);
    window.$crisp.push(["config", "position:reverse", true]);
    window.$crisp.push(["config", "hide:on:mobile", false]);
    window.$crisp.push(["config", "button:hide", true]);
    const existing = document.getElementById("chtt");
    if (!existing) {
      const script = document.createElement("script");
      script.src = "https://client.crisp.chat/l.js";
      script.id = "chtt";
      script.async = true;
      script.onload = () => setTimeout(() => window.$crisp.push(["do", "chat:open"]), 1000);
      document.head.appendChild(script);
    } else {
      window.$crisp.push(["do", "chat:open"]);
    }
  }, []);

  return (
    <div style={{ display: "flex" }}>
      {/* Sidebar */}
      <div className="sidebar-responsive-wrapper">
        <Sidebar />
      </div>

      {/* Header bar */}
      <div className="header-wrapper">
        <div className="header-container">
          {/* Left: Menu + Logo */}
          <div className="header-left">
            <div className="menu-icon-bg" onClick={handleMenuClick}>
              <MenuIcon />
            </div>
            <Link to="/" className="header-logo">
              <img
                src="./assets/logo.png"
                alt="Logo"
                style={{ width: showLogo ? "100px" : "96px" }}
                onError={(e) => { e.target.src = "/assets/logo.png"; }}
              />
            </Link>
          </div>

          {/* Right */}
          <div className="header-right">
            {/* Search icon (desktop only) */}
            {!isMobile && (
              <div className="icon-bg" onClick={() => setSearchOpen(true)} style={{ cursor: "pointer" }}>
                <SearchIcon />
              </div>
            )}

            {isAuthenticated ? (
              <>
                {/* Credit/Wallet */}
                <HeaderCredit />

                {/* Gift/Bonus */}
                <div className="icon-bg" onClick={() => navigate("/bonus")} style={{ cursor: "pointer" }}>
                  <GiftSkyla size="20px" fill="#EDCC06" />
                </div>

                {/* Message + Notifications (desktop only) */}
                {!isMobile && (
                  <div className="icon-bg-group" style={{ display: "flex", alignItems: "center", gap: "4px", backgroundColor: "rgb(18, 20, 24)", borderRadius: "10px", padding: "6px 8px" }}>
                    <NotificationDropdown />
                  </div>
                )}

                {/* Profile: Desktop = dropdown menu, Mobile = avatar link */}
                {!isMobile ? (
                  <ProfileMenu />
                ) : (
                  <Link to="/mobile-user" style={{ flexShrink: 0 }}>
                    <img
                      src={storage.getKey("avatar") || DEFAULT_AVATAR}
                      alt="Profile"
                      style={{ width: 32, height: 32, borderRadius: "50%", objectFit: "cover" }}
                      onError={(e) => { e.target.onerror = null; e.target.src = DEFAULT_AVATAR; }}
                    />
                  </Link>
                )}
              </>
            ) : (
              <div className="auth-buttons">
                <button className="btn-sign-in" onClick={() => useAuthModalStore.getState().openLogin()}>Sign in</button>
                <button className="btn-sign-up" onClick={() => useAuthModalStore.getState().openRegister()}>Sign up</button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Global Search Modal */}
      <GlobalSearch isOpen={searchOpen} onClose={() => setSearchOpen(false)} />
    </div>
  );
};

export default Header;
